import QuantitySelector from "./QuantitySelector";

export { QuantitySelector };
export default QuantitySelector;
